module.exports = __webpack_public_path__ + "img/management-feature-3.0acb41ea.svg";